import script from "./PhieuXuatKhoVatTuThuHoiCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhieuXuatKhoVatTuThuHoiCell.vue?vue&type=script&lang=ts&setup=true"

import "./PhieuXuatKhoVatTuThuHoiCell.vue?vue&type=style&index=0&id=bd6ba4e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6ba4e6"]])

export default __exports__